module.exports = __webpack_public_path__ + "img/google-auth-null.d8ca0c91.svg";